import axios from 'axios'
import moment from 'moment'
import Firebase from '@firebase/app'
import { refreshToken } from 'redux/modules/auth'
import {
  MODAL_NETWORK_OFF,
  MODAL_SERVER_DOWN,
  showModal
} from 'redux/modules/modals'

export default class Api {
  instance
  getState
  config
  constructor(dispatch, getState, authConfig) {
    const auth = authConfig || getState().auth
    let baseUrl = 'https://us-central1-dashpool-prod.cloudfunctions.net/api'
    if (__DEV__) baseUrl = 'http://localhost:5000/dashpool-dev/us-central1/api'
    if (__STAGING__) {
      baseUrl = 'https://us-central1-dashpool-dev.cloudfunctions.net/api'
    }
    this.config = {
      baseURL: baseUrl,
      headers: {
        Authorization: auth.bearer
      },
      timeout: 60000
    }
    const instance = axios.create(this.config)
    instance.interceptors.request.use(
      conf => {
        return conf
      },
      err => {
        console.error(err)
        return Promise.reject(err)
      }
    )
    instance.interceptors.response.use(this.handleSuccess, this.handleError)

    this.instance = instance
    this.dispatch = dispatch
    this.getState = getState
  }
  handleSuccess = response => {
    return response
  }
  handleError = error => {
    const originalRequest = error.config
    if (error.message === 'Network Error') {
      if (this.getState().auth.isOnline) {
        this.dispatch(showModal(MODAL_SERVER_DOWN))
        Rollbar.critical('Server Down Error ', error.config)
      } else {
        this.dispatch(showModal(MODAL_NETWORK_OFF))
      }
      return Promise.reject(error)
    }
    if (!error.response) {
      return Promise.reject(error)
    }
    switch (error.response.status) {
      case 400:
        // this.redirectTo(document, '/')
        break
      case 401:
        if (error.config && !error.config.__isRetryRequest) {
          return Firebase.auth()
            .currentUser.getIdToken(/* forceRefresh */ true)
            .then(idToken => {
              this.dispatch(refreshToken(idToken))
              originalRequest.__isRetryRequest = true
              originalRequest.headers.Authorization = `Bearer ${idToken}`
              return this.instance.request(originalRequest)
            })
            .catch(err => {
              Rollbar.error('Firebase getIdToken Error ', err)
              return Promise.reject(err)
            })
        } else {
          Rollbar.error('Retry Error ', error)
          return Promise.reject(error)
        }
      case 404:
        Rollbar.warning('404 - Route Not Found', error)
        break
      case 500:
        Rollbar.critical('500 - Server Error', error)
        break
      default:
        Rollbar.critical('Unknow Error', error)
        break
    }
    return Promise.reject(error)
  }
  addBucketRequest(method, path, payload, action) {
    return new Promise((resolve, reject) => {
      const { firebase } = this.getState()
      firebase.child('hiboutikApi/bucketRequest').push(
        {
          date: moment().format(),
          method: method,
          url: path,
          payload: payload || null,
          auth: this.config.auth,
          action: action
        },
        err => {
          if (err) {
            return reject(err)
          }
          return resolve({ response: { status: 0, data: null } })
        }
      )
    })
  }
  get(path, config) {
    return this.instance.get(path, config)
  }
  post(path, payload, config) {
    return this.instance.post(path, payload, config)
  }
  put(path, payload, config) {
    return this.instance.put(path, payload, config)
  }
  delete(path, config) {
    return this.instance.delete(path, config)
  }
}



// WEBPACK FOOTER //
// ./src/dashpoolApi/index.js